const Pagina404 = () => {
    return (<><div>404</div></>);
};

export default Pagina404;